export default {
  // @WORKING ON GROUP FILTER - do not remove commented code

  // specialitySubSpeciality: {
  //   name: "specialitySubSpeciality",
  //   label: "Speciality/Sub-Speciality",
  //   component: "groupFilterSelect",
  //   schema: {
  //     SPASUBcountry: {
  //       name: "SPASUBcountry",
  //       component: "filterSelect",
  //       label: "Country",
  //       queryKey: "country_query_key",
  //       dependsOn: [],
  //       dependentFilter: [],
  //       taggable: false,
  //       multiple: true
  //     },
  //     SPASUBspecialityOrSubSpeciality: {
  //       name: "SPASUBspecialityOrSubSpeciality",
  //       component: "filterSelect",
  //       label: "Speciality/Sub-Speciality",
  //       queryKey: "hospitalexclude_query_key",
  //       dependsOn: [],
  //       dependentFilter: [],
  //       taggable: false,
  //       multiple: true,
  //       filterDynamicSearchAction: "test"
  //     }
  //   }
  // },
  partnerHospitals: {
    name: "partnerHospitals",
    component: "filterSelect",
    label: "Organisation",
    placeholder: "All",
    queryKey: "organisation_uid__in",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
  },
  candidateType: {
    name: "candidateType",
    component: "filterSelect",
    label: "Job Category",
    placeholder: "All",
    queryKey: "candidate_type_id__in",
    dependsOn: [],
    dependentFilter: ["candidateLevelJob", "specialitySearch", "AHPSpeciality"],
    secondLevelDependentDisable: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  candidateLevelJob: {
    name: "candidateLevelJob",
    component: "filterSelect",
    label: "Role / Level",
    queryKey: "agg_targeted_level_ids__overlap",  
    dependsOn: ["candidateType"],
    secondLevelDependentDisable: ["candidateType"],
    taggable: false,
    multiple: true,
    hideCondition: {
      conditionalField: "candidateType",
      value: [3],
      defaultShow: true,
    }
  },
  AHPSpeciality: {
    name: "AHPSpeciality",
    component: "filterSelect",
    label: "Role / Level",
    queryKey: "speciality_id__in",
    dependsOn: ["candidateType"],
    secondLevelDependentDisable: ["candidateType"],
    taggable: false,
    multiple: true,
    hideCondition: {
      conditionalField: "candidateType",
      value: [1, 2, 4, 6],
      defaultShow: false,
    }
  },
  specialitySearch: {
    name: "specialitySearch",
    component: "accordionSelect",
    label: "Area of Expertise",
    queryKey: "speciality_references",
    dependsOn: [],
    dependentFilter: [],
    secondLevelDependentDisable: ["candidateType"],
    taggable: false,
    multiple: true,
    clearable: false,
    filterDynamicSearchAction: "genericSpecialitySearch",
    dependentQuerys: ["candidateType"],
    placeholder: "Start typing to here..."
  },
  // speciality: {
  //   name: "speciality",
  //   component: "filterSelect",
  //   label: "Speciality",
  //   queryKey: "speciality_id__in",
  //   dependsOn: ["candidateType"],
  //   secondLevelDependentDisable: ["candidateType"],
  //   dependentFilter: ["subSpeciality"],
  //   taggable: false,
  //   multiple: true
  // },
  // subSpeciality: {
  //   name: "subSpeciality",
  //   component: "filterSelect",
  //   label: "Sub Speciality",
  //   queryKey: "sub_speciality_id__in",
  //   dependsOn: ["candidateType"],
  //   secondLevelDependentDisable: ["speciality"],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: true
  // },
  // ageLimit: {
  //   name: "ageLimit",
  //   component: "filterRange",
  //   label: "Age limit",
  //   queryKey: "maximum_age",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   selected: [20], //default value
  //   min: 20,
  //   max: 70,
  //   type: "range"
  // },
  // salaryRange: {
  //   name: "salaryRange",
  //   component: "filterRange",
  //   label: "By Salary range​",
  //   queryKey: "salary__lte",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   selected: [20], //default value
  //   min: 20,
  //   max: 70,
  //   type: "range"
  // },
  // contractOptions: {
  //   name: "contractOptions",
  //   component: "filterSelect",
  //   label: "By Contract",
  //   queryKey: "contract_query_key",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: false,
  // },
  locationRegion: {
    name: "locationRegion",
    component: "filterSelect",
    label: "Region",
    queryKey: "agg_region_ids__overlap",
    placeholder: "All",
    dependsOn: [],
    groupFilterName: "Region/ Country/ Location",
    dependentFilter: ["locationCountry", "locations"],
    apiDependentFilter: ["locationCountry"],
    taggable: false,
    multiple: true,
    clearable: true,
    showCount: true,
  },
  locationCountry: {
    name: "locationCountry",
    component: "filterSelect",
    label: "Country",
    queryKey: "agg_country_ids__overlap",
    dependsOn: ["locationRegion"],
    clearOnlyDepends: true,
    groupFilterName: "Region/ Country/ Location",
    dependentFilter: ["locations"],
    placeholder: "All",
    // secondLevelDependentDisable: ["locationRegion"],
    taggable: false,
    multiple: true,
    clearable: true,
    showCount: true,
  },
  locations: {
    name: "locations",
    component: "filterSelect",
    label: "Location",
    queryKey: "agg_location_id__in",
    dependsOn: ["locationRegion", "locationCountry"],
    clearOnlyDepends: true,
    groupFilterName: "Region/ Country/ Location",
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: true,
    placeholder: "All",
    showCount: true,
    valueConsistsOf: 'LEAF_PRIORITY'
  },
  // hospitalNames: {
  //   name: "hospitalNames",
  //   component: "filterSelect",
  //   label: "By Hospital",
  //   queryKey: "organisation_uid",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: false
  // },
  // postingDates: {
  //   name: "postingDates",
  //   component: "filterSelect",
  //   label: "By Posting Dates​",
  //   queryKey: "posting_dates_query_key",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: false,
  // },
  // voluntaryJobs: {
  //   name: "voluntaryJobs",
  //   component: "filterSelect",
  //   label: "By Voluntary jobs​",
  //   queryKey: "vj_query_key",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: false,
  //   clearable: false,
  // },
  // retiredJobs: {
  //   name: "retiredJobs",
  //   component: "filterSelect",
  //   label: "By Retired jobs​​",
  //   queryKey: "rj_query_key",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: false,
  //   clearable: false,
  // },
  // regionInclude: {
  //   name: "regionInclude",
  //   component: "filterSelect",
  //   label: "Region Include",
  //   queryKey: "include_country_id",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: true,
  // },
  // regionExclude: {
  //   name: "regionExclude",
  //   component: "filterSelect",
  //   label: "Region Exclude",
  //   queryKey: "exclude_country_id",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: true,
  // },
  // hospitalInclude: {
  //   name: "hospitalInclude",
  //   component: "filterSelect",
  //   label: "Hospital Include",
  //   queryKey: "hospitalInclude_query_key",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: true,
  // },
  // hospitalExclude: {
  //   name: "hospitalExclude",
  //   component: "filterSelect",
  //   label: "Hospital Exclude",
  //   queryKey: "hospitalexclude_query_key",
  //   dependsOn: [],
  //   dependentFilter: [],
  //   taggable: false,
  //   multiple: true,
  // },
  expiryFromTime: {
    name: "expiryFromTime",
    component: "filterDatePicker",
    label: "From-Time",
    queryKey: "include_marketplace=false&deleted=false&date_field=expiry_review_date&from_date",
    groupFilterName: "Job Expiry",
    dependsOn: [],
    secondLevelDependentDisable: [],
    dependentFilter: ["expiryToTime"],
    apiDependentFilter: ["expiryToTime"],
    taggable: false,
    multiple: false,
  },
  expiryToTime: {
    name: "expiryToTime",
    component: "filterDatePicker",
    label: "To-Time",
    queryKey: "include_marketplace=false&deleted=false&to_date",
    groupFilterName: "Job Expiry",
    dependsOn: [],
    // secondLevelDependentClear: ["expiryFromTime"],
    secondLevelDependentDisable: ["expiryFromTime"],
    dependentFilter: [],
    taggable: false,
    multiple: false,
  },
  contractType: {
    name: "contractType",
    component: "filterSelect",
    label: "Contract Type",
    queryKey: "contractType",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: false,
  },
  jobAvailability: {
    name: "jobAvailability",
    component: "filterSelect",
    label: "Full or Part Time",
    queryKey: "availabilityType",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: false,
    clearable: true,
  },
  published: {
    name: "published",
    component: "filterSelect",
    label: "Job Status",
    queryKey: "status_id__in",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: false,
  },
  jobGroups: {
    name: "jobGroups",
    component: "filterSelect",
    label: "Job Groups",
    queryKey: "group_ids__overlap",
    dependsOn: [],
    dependentFilter: [],
    taggable: false,
    multiple: true,
    clearable: false,
  },
};
